import styled from "styled-components";
import { darken } from "polished";
import { device } from "../../styles/device";
import ButtonSecondary from "../../components/ButtonSecondary";
import InputRadioCustom from "../../components/InputRadioCustom";
import ButtonPrimary from "../../components/ButtonPrimary";

export const ContentWrap = styled.div`
  display: flex;
  width: 100%;
  margin-top: 24px;
  align-items: flex-start;
  gap: 24px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const RevisionWrap = styled.div`
  padding-bottom: 32px;
  margin-bottom: 32px;
  border-bottom: solid 1px ${props => props.theme.colors.neutral100};
  width: 100%;
  max-width: 500px;

  @media ${device.laptop}{
    max-width: none;
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 0;
    flex: 1;
  }
`;

export const WarnContainer = styled.div`
  @media ${device.laptop}{
   	margin-right: 21px;
  }
`;

export const ContainerProducts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media ${device.tablet} {
    max-width: none;
    }
`;

export const PriceInfoWrap = styled.div`
  display: flex;
  width: 100%;
  max-width: 400px;
  flex-direction: column;
  align-items: stretch;
  background: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.neutral100};
  border-radius: 16px;
  box-shadow: var(--cards);
  padding: 24px;
  position: sticky;
  top: 24px;

  .linkCompra {
    font-size: 14px;
    font-weight: 700;
    color: ${(props) => props.theme.colors.primary};
    padding: 20px;
    cursor: pointer;
  }

  @media (max-width: 900px) {
    max-width: 100%;
    position: static;
  }
`;

export const Overlay = styled.div`
  width: 100vw;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 10000;
  top: 0;

  > div {
    background: #fff;
    display: flex;
    width: calc(100% - 16px);
    max-width: 400px;
    padding: 16px;
    border-radius: 10px;
    justify-content: center;

    span {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 400;
      margin-left: 8px;
      text-transform: capitalize;
    }
  }
`;

export const LoaderContainer = styled.div`
  width: 100%;
  max-width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;

  > div {
    align-items: center;
    display: flex;
  }
`;

export const TitleWrap = styled.div`
  margin-bottom: 20px;
  color: ${props => props.theme.colors.neutral900};
  font-family: 'Sora', system-ui, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: normal;
  align-self: start;
`;

export const DeliveryTitle = styled(TitleWrap)`
  margin-bottom: 0px;
  align-items: center;
`;

export const Line = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: space-between;
  margin-bottom: 11px;
  flex-wrap: wrap;
  gap: 20px;
`;

export const WhatWouldLikeToDoTitleWrap = styled(TitleWrap)`
  margin-top: 40px;
`;

export const StyledInputRadioCustom = styled(InputRadioCustom)`
  margin-bottom: 56px;
`;

export const PriceInfoContent = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  /* Desconto do Pix online, informativo abaixo do total (P-113) */
  &.pix-discount span.price-description,
  &.pix-discount span.price-value {
    padding: 0 0 8px;
    font-size: 14px;
    color: ${props => props.theme.colors.success};
  }

  :has(>.total) {
    padding-top: 16px;
    margin-top: 12px;
    border-top: solid 1px ${props => props.theme.colors.neutral100};
  }

  span.price-value {
    padding: 8px 0;
    font-family: 'DM Sans', system-ui, sans-serif;
    font-size: 16px;
    color: ${props => props.theme.colors.neutral900};
    font-weight: 700;
  }

  span.price-description {
    padding: 8px 0;
    font-family: 'DM Sans', system-ui, sans-serif;
    color: ${props => props.theme.colors.neutral600};
    font-size: 16px;
    font-weight: 500;
  }

  span.total {
    font-family: 'Sora', system-ui, sans-serif;
    font-weight: 700;
    font-size: 22px;
    color: ${props => props.theme.colors.neutral900};
  }

  &.discount span.price-value {
    color: ${props => props.theme.colors.success};
  }

  /* Taxa é custo, não erro: cor normal; riscada (frete grátis) em cinza. */
  &.delivery-fee {
    span.price-value {
      color: ${props => props.theme.colors.neutral900};
    }

    span.price-value span {
      color: ${props => props.theme.colors.neutral400};
    }
  }
`;

export const FreeShippingNote = styled.p`
  width: 100%;
  margin: -4px 0 4px;
  text-align: right;
  font-family: 'DM Sans', system-ui, sans-serif;
  font-size: 13px;
  color: ${props => props.theme.colors.neutral600};
`;

export const ButtonFooterWrap = styled.button`
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
  width: 100%;
  color: ${(props) => props.theme.colors.white};
  background: ${(props) => props.theme.colors.primary};
  font-size: 1.6rem;
  font-weight: 700;
  border-radius: 999px;
  font-family: 'DM Sans', system-ui, sans-serif;
  border: none;
  transition: background 200ms ease;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: ${(props) => darken(0.08, props.theme.colors.primary)};
  }

  :disabled {
    background: var(--neutral-200, #D0D1D3);
    color: var(--neutral-800, #44474E);
    cursor: not-allowed;
  }

  > div {
    margin-top: 5px;
    margin-right: 12px;
  }

  span {
    font-weight: 500;
    margin-left: 5px;
  }
`;

export const StyledButtonPrimary = styled(ButtonPrimary)`
  width: 100%;
  margin-top: 24px;
  border-radius: 999px;
`;

export const StyledButtonSecondary = styled(ButtonSecondary)`
  width: 100%;
  margin-top: 12px;
  border: none;

  &:hover {
    border: none;
    background: transparent;
    color: ${(props) => darken(0.1, props.theme.colors.primary)};
  }
`;

export const AttachPrescriptionButton = styled.button`
  display: flex;
  gap: 6px;
  background: transparent;
  align-items: center;
  border: none;
  color: ${props => props.theme.colors.primary};
  font-size: 14px;
  font-weight: 700;
`;
